import React from 'react';
import { useMediaQuery, useTheme as useMuiTheme, Button } from '@material-ui/core';
import { mdiSchoolOutline, mdiMenuDown, mdiImageFilterCenterFocusStrong, mdiBullseyeArrow, mdiMenuRight, mdiClipboardCheckOutline } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { usePopover } from '../../hooks/usePopover';
import { IconSize } from '../../lib';
import { TooltippedIconButton } from '../Buttons';
import { StyledListItem, StyledMenu } from './index.styles';
export var LearningMode;
(function (LearningMode) {
    LearningMode["ACCOUNTABILITY"] = "Accountability mode";
    LearningMode["ASSESSMENT"] = "Assessment mode";
    LearningMode["STANDARD"] = "Standard mode";
    LearningMode["FOCUS"] = "Focus mode";
})(LearningMode || (LearningMode = {}));
const MODE_TO_ICON = {
    [LearningMode.ACCOUNTABILITY]: mdiBullseyeArrow,
    [LearningMode.ASSESSMENT]: mdiClipboardCheckOutline,
    [LearningMode.STANDARD]: mdiSchoolOutline,
    [LearningMode.FOCUS]: mdiImageFilterCenterFocusStrong
};
const StyledIcon = styled(Icon) `
    margin-left: auto;
    margin-right: 0 !important;
`;
export const LearningModeMenu = ({ variant = 'listItem', mode = LearningMode.STANDARD, closeParent, disabledModes = [], onChangeLearningMode }) => {
    const muiTheme = useMuiTheme();
    const displayFullButton = useMediaQuery(muiTheme.breakpoints.up('sm'));
    const { open, anchorEl, handlePopoverClick, handlePopoverClose } = usePopover();
    return (React.createElement(React.Fragment, null,
        variant === 'listItem' ? (React.createElement(StyledListItem, { button: true, onClick: (e) => {
                e.stopPropagation();
                handlePopoverClick(e);
            } },
            React.createElement(Icon, { path: MODE_TO_ICON[mode] }),
            mode,
            React.createElement(StyledIcon, { path: mdiMenuRight, size: IconSize.Medium }))) : displayFullButton ? (React.createElement(Button, { color: "primary", onClick: handlePopoverClick, startIcon: React.createElement(Icon, { size: IconSize.Small, path: MODE_TO_ICON[mode] }), endIcon: React.createElement(Icon, { size: IconSize.Small, path: mdiMenuDown }) }, mode)) : (React.createElement(TooltippedIconButton, { title: "Learning mode", icon: React.createElement(Icon, { path: MODE_TO_ICON[mode] }), onClick: handlePopoverClick })),
        React.createElement(StyledMenu, { getContentAnchorEl: null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: {
                vertical: 'bottom',
                horizontal: 'right'
            }, anchorEl: anchorEl, open: open, onClose: handlePopoverClose, onClick: (e) => {
                e.stopPropagation();
                handlePopoverClose();
                if (closeParent) {
                    closeParent();
                }
            } }, Object.entries(MODE_TO_ICON).map(([modeOption, icon]) => (React.createElement(StyledListItem, { button: true, disabled: disabledModes.includes(modeOption), selected: modeOption === mode, key: modeOption, onClick: () => onChangeLearningMode(modeOption) },
            React.createElement(Icon, { path: icon }),
            " ",
            modeOption))))));
};
//# sourceMappingURL=LearningModeMenu.js.map